import { render, staticRenderFns } from "./PKCSForm.vue?vue&type=template&id=1a27bfac&"
import script from "./PKCSForm.vue?vue&type=script&lang=js&"
export * from "./PKCSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a27bfac')) {
      api.createRecord('1a27bfac', component.options)
    } else {
      api.reload('1a27bfac', component.options)
    }
    module.hot.accept("./PKCSForm.vue?vue&type=template&id=1a27bfac&", function () {
      api.rerender('1a27bfac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/PKCSForm.vue"
export default component.exports